import React from 'react'

interface InfoAlertProps {
  title: string
  description: string
  variant?: 'info' | 'warning'
}

export const InfoAlert: React.FC<InfoAlertProps> = ({ 
  title, 
  description, 
  variant = 'info' 
}) => {
  const bgColor = variant === 'info' ? 'bg-blue-50' : 'bg-yellow-50'
  const iconColor = variant === 'info' ? 'text-blue-600' : 'text-yellow-600'
  const titleColor = variant === 'info' ? 'text-blue-900' : 'text-yellow-900'
  const textColor = variant === 'info' ? 'text-blue-700' : 'text-yellow-700'

  return (
    <div className={`mt-6 p-4 ${bgColor} rounded-lg`}>
      <div className="flex items-start">
        <svg
          className={`w-5 h-5 ${iconColor} mt-0.5`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div className="ml-3">
          <p className={`text-sm ${titleColor} font-medium`}>
            {title}
          </p>
          <p className={`text-xs ${textColor} mt-1`}>
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}